import { Component, Input, OnInit } from '@angular/core'
import { BlockFieldsService } from 'src/app/block-services/block-fields.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { BlockDataService } from '../../block-services/block-data.service'

import { ProductsService } from '../block-products/products.service'
import { ProductsService as standaloneProductsService } from '../../e-commerce/products/products.service'
import { CategoriesService as standaloneCategoriesService } from '../../e-commerce/categories/categories.service'
import { CategoriesService } from '../block-categories/categories.service'
import { PostsService } from '../block-posts/posts.service'
import { MatSelectChange } from '@angular/material/select'
import { CheckoutField, CheckoutFieldsService } from '../../e-commerce/shipping-providers/shared/checkout-fields.service'
@Component({
  selector: 'block-static',
  templateUrl: './block-static.component.html',
  styleUrls: ['./block-static.component.scss']
})
export class BlockStaticComponent implements OnInit {
  previewBlock = false
  styleFields = false
  blockData: any
  pages: Array<any> = []

  previewFields = false

  blockFields: any

  blockId = ''

  @Input() nestedBlock: any = {}
  @Input() importedBlockData: any
  @Input() builderType: 'mobile' | 'website' = 'mobile'
  showProgress = false
  storedCategories: any = []
  storedPosts: any = []
  storedProducts: any = []
  selectedRedirect: string = ''

  // Track which checkout fields are expanded
  expandedFields: Set<string> = new Set()

  // Checkout fields resolved from the project's enabled shipping provider
  checkoutFields: CheckoutField[] = []

  // Source of the checkout fields (manual, aymakan, etc.)
  checkoutFieldsSource: string = 'manual'

  constructor(
    private blockDataService: BlockDataService,
    private blockFieldsService: BlockFieldsService,
    public builderService: BuilderService,
    private productsService: ProductsService,
    public standaloneProductsService: standaloneProductsService,
    public categoriesService: CategoriesService,
    public standaloneCategoriesService: standaloneCategoriesService,
    private postsService: PostsService,
    private checkoutFieldsService: CheckoutFieldsService
  ) {}

  ngOnInit() {
    const initialRedirectTo = this.getBlockFields(this.blockId).data?.redirectTo || ''
    this.selectedRedirect = initialRedirectTo

    if (this.importedBlockData) {
      this.previewBlock = true
      this.previewFields = false
      this.styleFields = false
    }
    if (this.nestedBlock.type == 'static') {
      this.blockData = this.nestedBlock
      this.blockId = this.nestedBlock.id
      this.previewBlock = true
    } else {
      this.blockData = this.importedBlockData ? this.importedBlockData : this.blockFieldsService.staticBlockData
      // Use the imported block's ID if it exists, otherwise generate a new one
      if (this.importedBlockData && this.importedBlockData.id) {
        this.blockId = this.importedBlockData.id
      } else if (!this.blockId) {
        this.blockId = this.blockDataService.getUniqueId(2)
      }
    }

    if (this.checkSettings()) {
      this.showDataTab()
    }

    if (this.getBlockFields(this.blockId).data?.view == 'checkout') {
      this.loadCheckoutFields()
    }
  }

  /**
   * Loads the checkout fields for the current project's enabled shipping provider.
   * The backend returns the default field set when no provider is enabled, so the
   * component holds no hardcoded knowledge of the fields. Also captures the source
   * to determine whether fields are editable (manual) or read-only (provider-specific).
   */
  private loadCheckoutFields() {
    const projectId = String(this.builderService.selectedProject)
    this.checkoutFieldsService.fields$.subscribe((fields) => {
      this.checkoutFields = fields
    })
    this.checkoutFieldsService.source$.subscribe((source) => {
      this.checkoutFieldsSource = source
    })
    this.checkoutFieldsService.loadFields(projectId)
  }

  // getStaticVariationImage(blockId: string) {
  //   let blockView = this.getBlockFields(blockId).data.view;

  //   let variationView = this.getBlockFields(blockId).data.variations.block;
  //   return "../../../assets/images/views/components/"+blockView+"/"+variationView+".png";
  // }
  /**
   * Appends Block to the Preview, Initial checks if the block is added as initial block addition or appended live
   */
  addBlockToPreview(initial: any = '') {
    let blockStaticData = {
      component: BlockStaticComponent,
      index: 'latest',
      element: this,
      initial: initial
    }

    this.blockDataService.sendBlockData(blockStaticData)
  }

  appendBlock($event: any) {
    let clonedBlockData = { ...this.blockData }
    this.blockId = this.blockDataService.appendBlocksData(clonedBlockData)
    this.addBlockToPreview()
    this.builderService.logData('Image Block Added', 'Block Add', 'Image Block Added').subscribe(
      (response) => {},
      (err) => {}
    )
  }

  /**
   * Sync the clicked block on click inside the mobile preview
   */
  showData(blockId: any) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      // show data of the last element instead
      blockId = this.blockDataService.getLatestBlockId()
    }
    this.blockFieldsService.clickedBlockId = blockId
    this.blockDataService.sendCurrentBlock(BlockStaticComponent)
  }

  styleChange(style: any, blockId: any, $event: any, type: string) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let textBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...textBlockFields.style }
    let data = ''
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value
    } else if (type == 'slider') {
      data = $event.currentTarget.value + 'px'
    }

    clonedBlockFieldsData[style] = data
    textBlockFields.style = clonedBlockFieldsData
  }

  /**
   * The static-block preview is a pre-rendered screenshot named
   * `<layout>_<columns>_<style>.png`, and that matrix was never filled in for every
   * combination (Clean Style has a single three-column grid shot). When the exact
   * file is missing, walk down a fixed list of nearest matches, one step per error:
   * the same style at three columns, the same style's grid shot, the same layout in
   * the default style, then the default grid. The list only moves forward, so it
   * always ends; and a new combination loads a file that isn't in the old list, so
   * the walk restarts on its own.
   */
  variationImageFallback($event: Event, blockId: string) {
    const img = $event.target as HTMLImageElement
    const fields = this.getBlockFields(blockId)
    const data = fields?.data
    const style = fields?.style
    if (!img || !data?.variation_1) {
      return
    }
    const layout = data.variation_1[style?.grid_list] || data.variation_1['gridStyle']
    const columns = data.variation_2?.[style?.columns_number] || data.variation_2?.['threeColumns']
    // Blocks saved before a style was added to variation_3 still carry its name.
    const shape = data.variation_3?.[style?.products_style] || style?.products_style || 'simpleStyle'
    const candidates = [`${layout}_threeColumns_${shape}`, `grid_threeColumns_${shape}`, `${layout}_${columns}_simpleStyle`, 'grid_threeColumns_simpleStyle'].map(
      (name) => new URL(`../../../assets/images/views/components/${data.view}/${name}.png`, document.baseURI).href
    )
    const next = candidates.slice(candidates.indexOf(img.src) + 1).find((candidate) => candidate !== img.src)
    if (next) {
      img.src = next
    }
  }

  getBlockFields = (id: string) => {
    if (this.importedBlockData) {
      return this.importedBlockData
    }
    return this.blockDataService.getSelectedBlockData(id)
  }

  showStyleTab = () => {
    this.previewBlock = false
    this.previewFields = false
    this.styleFields = true
  }

  showDataTab = () => {
    this.previewBlock = false
    this.previewFields = true
    this.styleFields = false
  }

  checkSidebar = () => {
    if (!this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkPreview = () => {
    if (this.previewBlock && !this.previewFields && !this.styleFields) {
      return true
    }
    return false
  }

  checkData = () => {
    if (this.previewFields) {
      return true
    }
    return false
  }

  checkStyle = () => {
    if (this.styleFields && !this.previewFields && !this.previewBlock) {
      return true
    }
    return false
  }

  checkSettings = () => {
    if (!this.checkSidebar() && !this.checkPreview()) {
      return true
    }
    return false
  }

  /**
   * Deletes the Block from the mobile Preview
   * Deletes the Block from the JSON Object
   */
  deleteBlock = (blockId: any) => {
    this.blockDataService.removeBlockData(blockId)
  }

  queryChange(query: any, blockId: any, $event: any, type: string) {
    // Check Block Availability before taking action
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let buttonBlockFields = this.blockDataService.getSelectedBlockData(blockId)
    /**
     * Modifying Nested Object Directly doesn't work, so we have to clone the data object first then modify it
     */
    let clonedBlockFieldsData = { ...buttonBlockFields.data }
    let data = ''
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value
    } else if (type == 'slider') {
      data = $event.currentTarget.value + 'px'
    } else if (type == 'sliderPercentage') {
      data = $event.value + '%'
    }

    clonedBlockFieldsData[query] = data
    buttonBlockFields.data = clonedBlockFieldsData
  }

  getBlockFieldsCustomPage = (id: string) => {
    if (this.importedBlockData) {
      return this.importedBlockData
    }
    if (!this.blockDataService.blocksData) {
      return false
    }
    return this.blockDataService.getSelectedBlockData(id)
  }
  getPosts = (projectId: number, args: object, cached = true) => {
    this.showProgress = true
    if (cached) {
      this.postsService.getPostsCached().subscribe(
        (response) => {
          this.showProgress = false
          let posts: any = []
          for (const key in response) {
            if (Object.prototype.hasOwnProperty.call(response, key)) {
              const element = response[key]
              if (element) {
                posts.push({ ID: element.ID, post_title: element.post_title, post_image: element.post_image })
              }
            }
          }
          this.storedPosts = posts
        },
        (err) => {}
      )
    } else {
      this.postsService.getPosts(projectId, args).subscribe(
        (response) => {
          this.showProgress = false
          let posts: any = []
          for (const key in response) {
            if (Object.prototype.hasOwnProperty.call(response, key)) {
              const element = response[key]
              if (element) {
                posts.push({ ID: element.ID, post_title: element.post_title, post_image: element.post_image })
              }
            }
          }
          this.storedPosts = posts
        },
        (err) => {}
      )
    }

    return true
  }

  getProducts = (projectId: number, args: object, cached = true) => {
    this.showProgress = true
    if (cached) {
      this.productsService.getProductsCached().subscribe(
        (response) => {
          this.showProgress = false
          let products: any = []
          let responseProducts = response.products
          for (const key in responseProducts) {
            if (Object.prototype.hasOwnProperty.call(responseProducts, key)) {
              const element = responseProducts[key]
              if (element) {
                products.push({ id: element.id, name: element.name })
              }
            }
          }
          this.storedProducts = products
        },
        (err) => {}
      )
    } else {
      this.productsService.getProducts(projectId, args).subscribe(
        (response) => {
          this.showProgress = false
          let products: any = []
          let responseProducts = response.products
          for (const key in responseProducts) {
            if (Object.prototype.hasOwnProperty.call(responseProducts, key)) {
              const element = responseProducts[key]
              if (element) {
                products.push({ id: element.id, name: element.name })
              }
            }
          }
          this.storedProducts = products
        },
        (err) => {}
      )
    }

    return true
  }

  getStandaloneCategories = () => {
    this.standaloneCategoriesService.getCategories().subscribe((response: any) => {
      let categories: any = []
      for (const key in response) {
        if (Object.prototype.hasOwnProperty.call(response, key)) {
          const element = response[key]
          categories.push({ id: element.categoryId, name: element.categoryName, thumbnail: element.categoryImage })
        }
      }
      this.standaloneCategoriesService.storedStandaloneCategories = categories
    })
  }

  onRedirectSelectionChange(event: MatSelectChange) {
    this.selectedRedirect = event.value
    this.queryChange('redirectTo', this.blockId, event, 'select')
  }

  // Checkout field expansion management
  toggleFieldExpansion = (fieldKey: string) => {
    if (this.expandedFields.has(fieldKey)) {
      this.expandedFields.delete(fieldKey)
    } else {
      this.expandedFields.add(fieldKey)
    }
  }

  isFieldExpanded = (fieldKey: string): boolean => {
    return this.expandedFields.has(fieldKey)
  }

  /**
   * Resolves the current "Show/Hide" state of a checkout field, preferring the saved
   * block value and falling back to the field's backend-provided default.
   * @param blockId - The current block ID.
   * @param field - The checkout field to resolve.
   * @returns The saved state value or the field's default.
   */
  getCheckoutFieldState = (blockId: string, field: CheckoutField): string => {
    return this.getBlockFields(blockId).data?.[field.key] ?? field.show
  }

  /**
   * Resolves whether a checkout field's "Required" toggle should be checked, preferring
   * the saved block value and falling back to the field's backend-provided default.
   * @param blockId - The current block ID.
   * @param field - The checkout field to resolve.
   * @returns True when the field is required.
   */
  isCheckoutFieldRequired = (blockId: string, field: CheckoutField): boolean => {
    const saved = this.getBlockFields(blockId).data?.[field.key + 'Required']
    return (saved ?? field.required) === 'on'
  }

  /**
   * Determines if a specific checkout field can be edited by the merchant.
   * - For manual source: all fields can be edited
   * - For provider sources (aymakan, etc.): only non-required fields can be edited
   * @param field - The checkout field to check
   * @returns True if the field can be edited, false if it's locked
   */
  canEditCheckoutField = (field: CheckoutField): boolean => {
    if (this.checkoutFieldsSource === 'manual') {
      return true
    }
    return field.required !== 'on'
  }

  // Custom checkout fields management
  addCustomField = (blockId: string) => {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let blockFields = this.blockDataService.getSelectedBlockData(blockId)
    let clonedData = { ...blockFields.data }

    if (!clonedData.customFields) {
      clonedData.customFields = []
    }

    const newField = {
      id: this.blockDataService.getUniqueId(2),
      label: '',
      type: 'text',
      required: 'off'
    }

    clonedData.customFields = [...clonedData.customFields, newField]
    blockFields.data = clonedData
  }

  removeCustomField = (blockId: string, fieldId: string) => {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let blockFields = this.blockDataService.getSelectedBlockData(blockId)
    let clonedData = { ...blockFields.data }

    if (clonedData.customFields) {
      clonedData.customFields = clonedData.customFields.filter((field: any) => field.id !== fieldId)
      blockFields.data = clonedData
    }
  }

  updateCustomField = (blockId: string, fieldId: string, property: string, value: string) => {
    if (!this.blockDataService.checkBlockAvailability(blockId)) {
      return
    }
    let blockFields = this.blockDataService.getSelectedBlockData(blockId)
    let clonedData = { ...blockFields.data }

    if (clonedData.customFields) {
      clonedData.customFields = clonedData.customFields.map((field: any) => {
        if (field.id === fieldId) {
          return { ...field, [property]: value }
        }
        return field
      })
      blockFields.data = clonedData
    }
  }

  getCustomFields = (blockId: string) => {
    const blockFields = this.getBlockFields(blockId)
    return blockFields?.data?.customFields || []
  }

  // TrackBy function to prevent re-rendering of custom fields
  trackByCustomFieldId = (_index: number, field: any): string => {
    return field.id
  }
}
